import { useEffect, useRef, useState } from 'react';
import { Grid } from 'antd';

/** Matches the hardcoded header height in @acast-tech/echo-navigation. */
export const ECHO_TOPNAV_HEIGHT = 64;

/** Matches echo-navigation's mobile header show/hide transition. */
export const ECHO_TOPNAV_STICKY_TRANSITION = 'transform 0.3s ease';

export type EchoTopNavStickyState = {
  isTopNavHidden: boolean;
};

/**
 * Tracks whether the Echo topnav is hidden on mobile (scroll down past 64px),
 * matching echo-navigation's internal scroll behavior. Use with a fixed sticky
 * `top: ECHO_TOPNAV_HEIGHT` and `translateY` to slide content below the topnav.
 */
const useEchoTopNavStickyOffset = (): EchoTopNavStickyState => {
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;
  const [isTopNavHidden, setIsTopNavHidden] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    if (!isMobile) {
      setIsTopNavHidden(false);
      return;
    }

    lastScrollY.current = window.scrollY;

    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsTopNavHidden(scrollY > lastScrollY.current && scrollY > ECHO_TOPNAV_HEIGHT);
      lastScrollY.current = scrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isMobile]);

  return { isTopNavHidden: isMobile && isTopNavHidden };
};

export default useEchoTopNavStickyOffset;
